/*  ==========================================================================
    POPUP
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import 'jquery-inview';

// local imports
/*
 * MODULE
 */

export function initPopup($element) {

    let $popup = $element;
    let $closeButton = $element.find('.js-closetrigger');

    $closeButton.on('click', function () {
        $popup.removeClass('js-act');
        sessionStorage.setItem('popup', 'false');
    });

    let popupState = sessionStorage.getItem('popup');

    if(popupState !== "false") {
        $popup.addClass('js-act');
    }

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/popup.js